import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { AddressImcompleteModalBody } from '../../components/location/address-imcomplete-modal-body';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function useAddressImcompleteModal() {
  const storage = useStorage();
  const { config } = storage;
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage });
  const { t } = useTranslation();

  const didOpen = () => {
    analyticsPageView('Imcomplete Address');
  };

  async function show({ placeDetails, baseLocation }) {
    const result = await swal.fire({
      title: t('address-incomplete-modal.title'),
      html: (
        <AddressImcompleteModalBody
          placeDetails={placeDetails}
          baseLocation={baseLocation}
          config={config}
          onCardClick={() => {
            swal.clickCancel();
          }}
        />
      ),
      icon: 'error',
      didOpen,
      showDenyButton: false,
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: t('back'),
    });

    result.wasImcompleteBackButtonClicked = true;

    return result;
  }

  return {
    showAddressImcompleteModal: show,
  };
}

export { useAddressImcompleteModal };
